import React, { useState, useRef, useEffect } from "react";
import { Link as DomLink, useLocation, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import {
  AppBar as MuiAppbar,
  Stack,
  Toolbar,
  Container,
  IconButton,
  Popover,
  MenuItem,
  Box,
  Divider,
  Typography,
  ListItem,
  ListItemButton,
  List,
  ListItemText,
  Drawer,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import LanguageIcon from "@mui/icons-material/Language";
import { useMyContext } from "../../MyContext";
import { useTranslation } from "react-i18next";
import {
  Link as ScrollLink,
  animateScroll as scroll,
  scroller,
} from "react-scroll";
import SocialIcons from "./SocialIcons";
import { getLocalizedPath } from "../../locales/routing";

function DrawerComp({
  handleLanguageSelect,
  headerRef,
  handleDrawerToggle,
  menuOnly,
}) {
  const navItems = ["about", "career"];
  const theme = useTheme();
  const { rest, setLang, setOnlyMenu } = useMyContext();
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const lang = i18n.language;

  const navigateToLocalized = (pathname) => {
    navigate(getLocalizedPath(lang, pathname));
  };

  return (
    <Box
      onClick={handleDrawerToggle}
      sx={{ textAlign: "center", color: "white" }}
    >
      <ListItemButton
        sx={{ textAlign: "center", textTransform: "uppercase" }}
        onClick={() => {
          navigateToLocalized("/");
        }}
      >
        <ListItemText primary={rest.name} />
      </ListItemButton>
      <Divider color="#cda45e" />
      <List>
        {menuOnly !== "2" && (
          <ListItem>
            <ListItemButton
              sx={{ textAlign: "center", textTransform: "uppercase" }}
              onClick={() => {
                setOnlyMenu(1);
                navigateToLocalized("/");
                setTimeout(() => {
                  scroller.scrollTo("menu", {
                    smooth: true,
                    offset: -headerRef?.current?.offsetTop || 0,
                  });
                }, 100);
              }}
            >
              <ListItemText primary={t("menu.Menu")} />
            </ListItemButton>
          </ListItem>
        )}
        <ListItem>
          <ListItemButton
            sx={{ textAlign: "center", textTransform: "uppercase" }}
            onClick={() => {
              setOnlyMenu(2);
              navigateToLocalized("/");
              setTimeout(() => {
                scroller.scrollTo("menu", {
                  smooth: true,
                  offset: -headerRef?.current?.offsetTop || 0,
                });
              }, 100);
            }}
          >
            <ListItemText primary="Beach Menu" />
          </ListItemButton>
        </ListItem>
        {navItems.map((item) => (
          <ListItem key={item}>
            <ListItemButton
              sx={{ textAlign: "center", textTransform: "uppercase" }}
              onClick={() => {
                navigateToLocalized(`/${item}`);
              }}
            >
              <ListItemText primary={t(`${item}.title1`)} />
            </ListItemButton>
          </ListItem>
        ))}
        {/* Language Switcher */}
        <Divider color="#cda45e" />
        <ListItem>
          <ListItemText
            sx={{ textAlign: "center", textTransform: "uppercase" }}
            primary="Languages"
          />
        </ListItem>
        <Divider color="#cda45e" />
        <Box
          sx={{
            mt: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            color: "text.green",
          }}
        >
          <MenuItem onClick={() => handleLanguageSelect("en")}>
            English
          </MenuItem>
          <MenuItem onClick={() => handleLanguageSelect("el")}>
            Ελληνικά
          </MenuItem>
          <MenuItem onClick={() => handleLanguageSelect("ru")}>
            Русский
          </MenuItem>
          <MenuItem onClick={() => handleLanguageSelect("de")}>
            Deutsch
          </MenuItem>
          <MenuItem onClick={() => handleLanguageSelect("se")}>
            {" "}
            Srpski{" "}
          </MenuItem>
          <MenuItem onClick={() => handleLanguageSelect("ua")}>
            {" "}
            Українська
          </MenuItem>
        </Box>
      </List>
      <Box
        sx={{
          justifyContent: "center",
          padding: 5,
        }}
      >
        <SocialIcons />
      </Box>
    </Box>
  );
}

export default DrawerComp;
